import { useState, useEffect } from 'react';
import { PatientFacialDetection } from '../../../components';
import { Flex, Image } from '../../../2022-component-library';
import { useReceiveMessage } from '../../../context/messageContext';
import RandomEImg from '../../../assets/img/rightE.bmp';

const ResponsiveRandomETestPatient = () => {
  const [logmarData, setLogmarData] = useState({});
  const messageFromOptician = useReceiveMessage();
  const [testMode, setTestMode] = useState('');

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'resizeLogmarImage':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          rotationDegree: messageFromOptician.content.rotationDegree,
        });
        break;
      case 'randomE':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          methodSelected: messageFromOptician.content.methodSelected,
          rotationDegree: messageFromOptician.content.rotationDegree,
        });

        if (messageFromOptician.content.methodSelected !== 'manual') {
          setTestMode('auto');
        } else {
          setTestMode(messageFromOptician.content.testMode);
        }
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex centered height='100vh' width='100vw'>
      <PatientFacialDetection testMode={testMode} />
      <Image src={RandomEImg} alt='random-e' width={logmarData.size} height={logmarData.size} rotate={`${logmarData?.rotationDegree || 0}deg`} />
    </Flex>
  );
};

export default ResponsiveRandomETestPatient;
